import { forwardRef, type ReactNode } from 'react'
import { AlertIcon, CheckIcon, InfoIcon } from '../icons'

export type NoticeTone = 'info' | 'success' | 'warning' | 'danger'

interface NoticeProps {
  tone?: NoticeTone
  title?: ReactNode
  children?: ReactNode
  /** `alert` for things the user must hear now; omit for ambient information. */
  role?: 'alert' | 'status'
  tabIndex?: -1
  className?: string
}

const ICONS = {
  info: InfoIcon,
  success: CheckIcon,
  warning: AlertIcon,
  danger: AlertIcon,
} as const

/**
 * Colour is never the only channel: every notice also carries an icon and a
 * title in words.
 */
export const Notice = forwardRef<HTMLDivElement, NoticeProps>(function Notice(
  { tone = 'info', title, children, role, tabIndex, className },
  ref,
) {
  const Icon = ICONS[tone]
  return (
    <div
      ref={ref}
      className={`notice notice--${tone}${className ? ` ${className}` : ''}`}
      role={role}
      tabIndex={tabIndex}
    >
      <Icon className="notice__icon" aria-hidden="true" focusable="false" />
      <div>
        {title ? <p className="notice__title">{title}</p> : null}
        {children ? <div className="notice__body">{children}</div> : null}
      </div>
    </div>
  )
})
